/*global $ */
export default function parseHashId (hashID) {
  if (typeof hashID !== 'undefined') {
    let hashArray = hashID.split('/');
    if (hashArray.length > 1) {
      if (hashArray[0] === '#news') {
        $(window).trigger($.Event('get:news', {nid: hashArray[1]}));
      }
    }
    return hashArray[0];
  }
  return hashID;
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/parseHashId.js